import React, { useState, useEffect } from 'react';
import MainCard from '../../../components/MainCard/MainCard';
import { Col, Row, Button } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import moment from 'moment/moment';
//Components
import TextField from '../../../components/TextField/TextField';
import Loading from '../../../components/Loading/Loading';
import RelatorioColetasDetalhado from './RelatorioColetasDetalhado';
//Api
import modalidadeColeta_api from '../../../api/modalidadeColeta_api';
import gerador_api from '../../../api/gerador_api';
import setor_api from '../../../api/setor_api';
import relatorio_api from '../../../api/relatorio_api';
import prefeitura_api from '../../../api/prefeitura_api';
//Helpers
import { validarCampos, objCampo, PrintValidate } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../helpers/message';
import { getSessionCookie } from '../../../helpers/cookies';

function initialStateFiltros() {
    const dataAtual = new Date();
    dataAtual.setMonth(dataAtual.getMonth() - 1);
    const dataInicial = moment(dataAtual).format("YYYY-MM-DD");
    dataAtual.setMonth(dataAtual.getMonth() + 1);
    const dataFinal = moment(dataAtual).format("YYYY-MM-DD");
    return {
        dataInicial,
        dataFinal,
        modalidadeId: 0,
        modalidadeId_selected: null,
        geradorId: 0,
        geradorId_selected: null,
        regional: "",
        regional_selected: null,
        status: "TODOS",
        tipo: "DETALHADO",
        nomeRelatorio: "Relatórios - Coletas Detalhado"
    }
}

export default function ColetasDetalhado() {
    //Variavel que guarda os dados do usuario logado
    const usuario = getSessionCookie();

    //Variavel utilizada para navegação 
    const navigate = useNavigate();

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado de controle dos erros nos campos obrigatorios
    const [errors, setErrors] = useState({});

    //Guarda os filtros obrigatorios
    const campos = [
        objCampo({ name: "dataInicial", required: true }),
        objCampo({ name: "dataFinal", required: true }),
    ]

    //Estado de controle dos valores dos filtros
    const [filtros, setFiltros] = useState(initialStateFiltros);

    //Opções de modalidades de coleta
    const [optionsModalidades, setOptionsModalidades] = useState();

    //Opções de transportadores
    const [optionsGeradores, setOptionsGeradores] = useState();

    //Opções do select de regionais
    const [optionsRegionais, setOptionsRegionais] = useState();

    //Estado que guarda os dados do relatorio
    const [dadosRelatorio, setDadosRelatorio] = useState(null);

    //Opções do select de status
    const optionsStatus = [
        { value: "TODOS", text: "Todos" },
        { value: "COLETADO", text: "Coletado" },
        { value: "BAIXADO", text: "Recebido" },
        { value: "NÃO COLETADO", text: "Recusado" },
    ]

    //Change para os campos data inicial, data final e status
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        })
    }

    //Change para os campos modalidade e transportadores
    const onChangeSelected = (e, select) => {
        const { name } = select;
        setFiltros({
            ...filtros,
            [name]: e,
            [name.split("_")[0]]: e ? e.value : 0
        });
    }
    //Função que puxa os dados do relatorio
    const carregarRelatorio = () => {

        const _errors = validarCampos(filtros, campos);

        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }
        if (new Date(filtros.dataInicial).getTime() > new Date(filtros.dataFinal).getTime()) {
            setErrors({ dataInicial: { message: "A data inicial não pode ser maior do que a data final" } })
            return;
        } else {
            setErrors({});
        }

        setLoading(true);
        const _filtros = { ...filtros }
        if (_filtros.regional_selected != null) {
            _filtros.regional = _filtros.regional_selected.label;
        }
        _filtros.dataInicial = _filtros.dataInicial + " 00:00:00"
        _filtros.dataFinal = _filtros.dataFinal + " 23:59:59"
        relatorio_api.ColetasDetalhado(_filtros).then(response => {
            response.data.listaColetas = response.data.listaColetas.map(coleta => {
                coleta.placaImplemento = coleta.veiculo + " / " + coleta.tipo_Veiculo
                Object.keys(coleta).map(value => {
                    if (!coleta[value]) {
                        coleta[value] = "Sem informação";
                    }
                });
                return coleta;
            });
            setDadosRelatorio(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));

    }
    //Carrega as modalidades de coleta, os geradores e as regionais para o select
    useEffect(() => {
        setLoading(true);
        modalidadeColeta_api.GetList().then(response => {
            response.data = response.data.map(value => {
                return { value: value.id, label: value.descricao };
            });
            setOptionsModalidades(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));

        if (usuario.acesso.modulo !== "Gerador") {
            gerador_api.GetList().then(response => {
                response.data = response.data.map(value => {
                    return { label: value.fantasia, value: value.id }
                });
                setOptionsGeradores(response.data);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            });
        }
        prefeitura_api.GetList().then(responsePrefeitura => {
            setor_api.GetList(responsePrefeitura.data[0].id).then(response => {
                response.data = response.data.map(value => {
                    return { value: value.id, label: value.descricao }
                })
                setOptionsRegionais(response.data);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            })
        })
    }, []);
    if (dadosRelatorio) {
        return <RelatorioColetasDetalhado
            dadosRelatorio={dadosRelatorio}
            btnVoltar={() => setDadosRelatorio(null)}
            filtros={filtros}
        />
    }
    return (
        <MainCard btnVoltarInTop={() => navigate(-1)}>
            {loading && <Loading />}
            <h4>Relatório de coletas detalhado</h4>
            <Row>
                <Col sm="12" md="6" lg="4">
                    <TextField name="dataInicial" label={"* Data inicial"} type={"date"} value={filtros.dataInicial} onChange={onChangeFiltros} invalid={!!errors.dataInicial} />
                    <PrintValidate field={"dataInicial"} errors={errors} />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField name="dataFinal" label={"* Data final"} type={"date"} value={filtros.dataFinal} onChange={onChangeFiltros} invalid={!!errors.dataFinal} />
                    <PrintValidate field={"dataFinal"} errors={errors} />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField placeholder='Selecione' name="modalidadeId_selected" label={"Modalidade"} type={"select"} searchable value={filtros.modalidadeId_selected} invalid={!!errors.modalidadeId_selected} onChange={onChangeSelected} options={optionsModalidades} />
                </Col>
                {usuario.acesso.modulo !== "Gerador" &&
                    <Col sm="12" md="6" lg="4">
                        <TextField placeholder='Todos' name="geradorId_selected" label={"Gerador"} type={"select"} searchable value={filtros.geradorId_selected} invalid={!!errors.geradorId_selected} onChange={onChangeSelected} options={optionsGeradores} />
                        <PrintValidate field={"geradorId_selected"} errors={errors} />
                    </Col>
                }
                <Col sm="12" md="6" lg="4">
                    <TextField placeholder='Todos' name="regional_selected" label={"Regional"} type={"select"} searchable value={filtros.regional_selected} invalid={!!errors.regional_selected} onChange={onChangeSelected} options={optionsRegionais} />
                    <PrintValidate field={"regional_selected"} errors={errors} />
                </Col>
                <Col sm="12" md="6" lg="4">
                    <TextField name="status" label={"* Status"} type={"select"} value={filtros.status} invalid={!!errors.status} onChange={onChangeFiltros} options={optionsStatus} />
                </Col>
                <Col sm="12" md="6" lg="4" style={{ marginTop: "1.875rem" }}>
                    <Button className='w-100 fw-bold' color='info text-light' onClick={carregarRelatorio}>Gerar Relatório</Button>
                </Col>
            </Row>
        </MainCard>
    )
}